import { useSyncExternalStore } from 'react';
import { useAppStore } from '@repletoryreach/sdk-utils/store';
import { prefersReducedMotionOs } from '@repletoryreach/sdk-utils/a11y';

function subscribeOsReduce(cb: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  mq.addEventListener('change', cb);
  return () => mq.removeEventListener('change', cb);
}

/** Returns 0 (full reduce), 1 (none), or 0.5 when partial mitigation kicks in. */
export function useReducedMotionMultiplier(): 0 | 0.5 | 1 {
  const mode = useAppStore((s) => s.reducedMotion);
  const osReduce = useSyncExternalStore(subscribeOsReduce, () => prefersReducedMotionOs(), () => false);
  if (mode === 'always') return 0;
  if (mode === 'never') return 1;
  return osReduce ? 0 : 1;
}
